import es from './i18n/es.json' with { type: 'json' };
import en from './i18n/en.json' with { type: 'json' };

export type Lang = 'es' | 'en';
export const LANGS: Lang[] = ['es', 'en'];
export type I18nKey = keyof typeof es;
export const DICTS: Record<Lang, Record<string, string>> = { es, en };

// Numbers in texts keep at most one decimal, with the language's own comma or point, and no grouping
// so integers read exactly as before.
const NUM: Record<Lang, Intl.NumberFormat> = {
  es: new Intl.NumberFormat('es-AR', { maximumFractionDigits: 1, useGrouping: false }),
  en: new Intl.NumberFormat('en-US', { maximumFractionDigits: 1, useGrouping: false }),
};

/** Translate with {var} interpolation. Falls back to Spanish, then to the key. */
export const translate = (lang: Lang, key: string, vars?: Record<string, string | number>): string => {
  let s = DICTS[lang][key] ?? DICTS.es[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, typeof v === 'number' ? NUM[lang].format(v) : v);
  return s;
};
